import {DDRDisplayData} from "../types/DDRDisplayData";
import {getApprovalLevelByAuthority} from "../utils/Enum";
import { getApiUrl } from '../config/api';

export const fetchStagingPlodsByAid = async (aid: number, isApproved: boolean = true) => {
    try {
        const response = await fetch(getApiUrl(`/api/TitelinePlod/GetStagingPlodsByAid?aid=${aid}&isApproved=${isApproved}`), {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching staging plods by Aid:', error);
        return null;
    }
};

export const fetchStagingPlodsByClientAid = async (aid: number, isApproved: boolean = true) => {
    try {
        const response = await fetch(getApiUrl(`/api/TitelinePlod/GetStagingPlodsByClientAid?aid=${aid}&isApproved=${isApproved}`), {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching staging plods by Aid:', error);
        return null;
    }
};

export const fetchAllStagingPlodsByAid = async (aid: number) => {
    try {
        const response = await fetch(getApiUrl(`/api/TitelinePlod/GetAllStagingPlodsByAid?aid=${aid}`), {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching staging plods by Aid:', error);
        return null;
    }
};

export const addStagingPlod = async (reportData : DDRDisplayData, aid: number, authorityLv: string) => {

    const authLv = authorityLv ? getApprovalLevelByAuthority(authorityLv) : null;

    const plodData = `'${reportData.date}', '${reportData.shift}', '${reportData.contract_no}', '${reportData.rig_no}', '${reportData.department}', null, null, '${reportData.location}', '${reportData.comments}', '${reportData.mach_hrs_from}', '${reportData.mach_hrs_to}', null, null, null, '${reportData.total_activity_hours}', null, null, 'DORS web entry', ${aid}, null, ${authLv}`;

    console.log('plodData', plodData);

    try {
        const response = await fetch(getApiUrl('/api/TitelinePlod/AddStagingPlod'), {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: `${plodData}`, // this is the same format as the iPad app
        });

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const result = await response.json();
        return result;
    } catch (error) {
        console.error('Error adding staging plod:', error);
        return null;
    }
};

export const updateStagingPlodDDRState = async (pid: number, isApprove: boolean) => {
    try {
        const response = await fetch(getApiUrl(`/api/TitelinePlod/UpdateStagingPlodDDRState?pid=${pid}&isApprove=${isApprove}`), {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const result = await response.json();
        return result;
    } catch (error) {
        console.error('Error updating staging plod DDR state:', error);
        return null;
    }
};

export const updateStagingPlod = async (reportData : DDRDisplayData) => {
    const payload = {
        Pid: reportData.pid,
        PlodDate: reportData.date,
        PlodShift: reportData.shift,
        ContractNo: reportData.contract_no,
        RigNo: reportData.rig_no,
        Department: reportData.department,
        Client: null,
        DayType: null,
        Location: reportData.location,
        Comments: reportData.comments,
        MachineHoursFrom: reportData.mach_hrs_from,
        MachineHoursTo: reportData.mach_hrs_to,
        TotalActivityHrs: reportData.total_activity_hours,
    };

    try {
        const response = await fetch(getApiUrl('/api/TitelinePlod/UpdateStagingPlod'), {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
        });

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const result = await response.json();
        return result;
    } catch (error) {
        console.error('Error updating staging plod:', error);
        return null;
    }
};

export const fetchAllContract = async (): Promise<string[]> => {
    try {
        const response = await fetch(
            getApiUrl('/api/TitelineLookups/GetLivingContracts'),
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            }
        );

        if (!response.ok) {
            console.error(`Error fetching contracts! Status: ${response.status}`);
            return [];
        }

        const data = await response.json();

        return data.Contracts ? data.Contracts : [];
    } catch (error) {
        console.error('Error fetching all living contracts:', error);
        return [];
    }
};

export const fetchSelectOptionsByContractNO = async (contractNo: string, category: string): Promise<string[]> => {
    try {
        const response = await fetch(
            getApiUrl(`/api/TitelineLookups/GetLookupValues/${contractNo}/${category}`),
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            }
        );

        if (!response.ok) {
            console.error(`Error fetching ${category} options for contract ${contractNo}! Status: ${response.status}`);
            return [];
        }

        const data = await response.json();

        return data.Values ? data.Values : [];
    } catch (error) {
        console.error(`Error fetching ${category} options for contract ${contractNo}:`, error);
        return [];
    }
};